import * as React from 'react';
import type { SVGProps } from 'react';
const SvgContentPaste = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={14}
    height={16}
    fill="currentColor"
    viewBox="0 0 14 16"
    {...props}
  >
    <path
      fill="currentColor"
      d="M1.5 16q-.62 0-1.06-.44A1.45 1.45 0 0 1 0 14.5v-11q0-.62.44-1.06T1.5 2h3.563A1.98 1.98 0 0 1 5.76.927 1.92 1.92 0 0 1 7 .5q.708 0 1.24.427.53.427.697 1.073H12.5q.619 0 1.06.44.44.442.44 1.06v11q0 .619-.44 1.06-.442.44-1.06.44zm0-1.5h11v-11H11v1.75q0 .319-.216.534A.73.73 0 0 1 10.25 6h-6.5a.73.73 0 0 1-.534-.216A.73.73 0 0 1 3 5.25V3.5H1.5zm5.496-11q.316 0 .535-.214a.71.71 0 0 0 .219-.532.74.74 0 0 0-.214-.535A.71.71 0 0 0 7.004 2a.74.74 0 0 0-.535.214.71.71 0 0 0-.219.532q0 .316.214.535t.532.219"
    />
  </svg>
);
export default SvgContentPaste;
